import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Payments from '../../Common/Payment';

class Payment extends Component {

  render() {
    //const { client, home } = this.props;
    const quoterData = { };

    return (
      <div>
        <Payments
          currency='USD'
          quoterData={quoterData}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    //client: state.client,
    //home: state.home,
  };
};

export default connect(mapStateToProps, null)(Payment);